<footer>
	<div class="row">
		<img src={{logo}} alt="Generalitat de Catalunya" />
	</div>
</footer>